import logo from '../../../asstes/admin-logo.png';
import { resolveMediaUrl } from '../../../apis/api';
import './invoiceDocument.css';

const BANK = {
  bankName: 'Indian Overseas Bank',
  name: 'SENTHILKUMAR A',
  branch: 'IOB BRANCH SEVALPATTI',
  accountNumber: '276602000000205',
  ifsc: 'IOBA0002766',
};

const SHOP_NAME = '3A SmartCrackers';

const formatINR = (n) => `₹${Number(n || 0).toFixed(2)}`;

const formatInvoiceDate = (d) => {
  if (!d) return '—';
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

const isPaymentConfirmed = (order) => {
  const paymentStatus = String(order.payment_status || 'pending').toLowerCase();
  return paymentStatus === 'confirmed' || paymentStatus === 'paid';
};

const renderPaymentStatusLabel = (order) => {
  const status = String(order.status || 'enquire').toLowerCase();
  if (status === 'enquire') return 'PENDING';
  if (isPaymentConfirmed(order)) return 'CONFIRMED';
  if (order.payment_proof || order.payment_proof_url) return 'PROOF RECEIVED';
  return 'INCOMPLETE';
};

const renderPaymentConfirmation = (order, proofSrc) => {
  if (proofSrc) {
    return (
      <a href={proofSrc} target="_blank" rel="noopener noreferrer">
        <img src={proofSrc} alt="Payment confirmation" className="invoice-doc__proof-img" />
      </a>
    );
  }

  const status = String(order.status || 'enquire').toLowerCase();
  if (status === 'enquire') {
    return <div className="invoice-doc__proof-fallback">Enquiry — payment not yet received</div>;
  }

  if (isPaymentConfirmed(order)) {
    return <div className="invoice-doc__proof-confirmed">Payment Confirmed</div>;
  }

  return <div className="invoice-doc__proof-incomplete">Payment Incomplete</div>;
};

export const InvoiceDocument = ({ order }) => {
  if (!order) return null;

  const items = order.items || [];
  const shippingCharge = Number(
    order.shipping_charge ?? Math.max(0, Number(order.total) - Number(order.subtotal))
  );
  const proofSrc =
    order.payment_proof_url ||
    (order.payment_proof
      ? resolveMediaUrl(`/uploads/payments/${String(order.payment_proof).split('/').pop()}`)
      : '');

  return (
    <div className="invoice-doc">
      <div className="invoice-doc__header">
        <div className="invoice-doc__title">INVOICE</div>
        <div className="invoice-doc__brand">
          <img src={logo} alt={SHOP_NAME} className="invoice-doc__logo" />
          <div className="invoice-doc__shop">{SHOP_NAME.toUpperCase()}</div>
        </div>
      </div>

      <div className="invoice-doc__meta">
        <div className="invoice-doc__issued">
          <div className="invoice-doc__section-label">ISSUED TO:</div>
          <div className="invoice-doc__issued-body">
            <div>{order.customer_name}</div>
            <div>{order.customer_mobile}</div>
            <div>{order.customer_email}</div>
            <div>{order.address}</div>
            <div>
              {order.city}, {order.state} - {order.pincode}
            </div>
          </div>
        </div>
        <div className="invoice-doc__info">
          <div>
            <strong>INVOICE NO:</strong> {order.invoice_no}
          </div>
          <div>
            <strong>DATE:</strong> {formatInvoiceDate(order.created_at)}
          </div>
          <div>
            <strong>STATUS:</strong> {String(order.status || 'enquire').toUpperCase()}
          </div>
          <div>
            <strong>PAYMENT:</strong> {renderPaymentStatusLabel(order)}
          </div>
        </div>
      </div>

      <table className="invoice-doc__items">
        <thead>
          <tr>
            <th align="left">DESCRIPTION</th>
            <th align="right">RATE</th>
            <th align="center">QTY</th>
            <th align="right">TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={4} className="invoice-doc__empty">No items</td>
            </tr>
          ) : (
            items.map((item) => (
              <tr key={item.order_item_id || `${item.product_id}-${item.product_name}`}>
                <td>{item.product_name}</td>
                <td align="right">{formatINR(item.unit_price)}</td>
                <td align="center">{item.quantity}</td>
                <td align="right">{formatINR(item.line_total)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="invoice-doc__totals-wrap">
        <table className="invoice-doc__totals">
          <tbody>
            <tr>
              <td>SUBTOTAL</td>
              <td align="right">{formatINR(order.subtotal)}</td>
            </tr>
            <tr>
              <td>Packing Charges</td>
              <td align="right">{formatINR(shippingCharge)}</td>
            </tr>
            <tr>
              <td>Tax</td>
              <td align="right">₹0.00</td>
            </tr>
            <tr className="invoice-doc__total-row">
              <td>TOTAL</td>
              <td align="right">{formatINR(order.total)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="invoice-doc__footer">
        <div className="invoice-doc__payment">
          <div className="invoice-doc__section-label">PAYMENT INFO:</div>
          <div className="invoice-doc__payment-body">
            <div>Bank Name: {BANK.bankName}</div>
            <div>Account Name: {BANK.name}</div>
            <div>Branch: {BANK.branch}</div>
            <div>Account No: {BANK.accountNumber}</div>
            <div>IFSC: {BANK.ifsc}</div>
            <div>Method: {String(order.payment_method || 'gpay').toUpperCase()}</div>
          </div>
        </div>
        <div className="invoice-doc__proof">
          <div className="invoice-doc__section-label">PAYMENT CONFIRMATION</div>
          {renderPaymentConfirmation(order, proofSrc)}
        </div>
      </div>

      <p className="invoice-doc__thanks">
        Thank you for ordering from {SHOP_NAME}. Have a sparkling celebration!
      </p>
    </div>
  );
};
